import { useState, useCallback } from "react";

function getDefaultState() {
  return {
    refreshCounter: 0,
    isHomeAddressVisible: false,
    books: [],
    isFirsTimeLoaded: false,
    isLoading: false,
    formHasChanged: false,
    selectedTabIndex: 0,
    defaultVisible: false,
    isNextTabVisible: true,
    refreshPopupVisible: false,
    ownersNames: [],
    phoneMask: [""],
    dataFromDB: null,
    user: null,
    phonesNumbers: [],
    XLClient: "",
    XLAccount: "",
    numOfVisibleTabs: 0,
    setDefaults: true,
    jsonFile: null,
    isMessagePopupVisible: false,
    popupData: null,
    popupMessage: "",
    popupTitle: "",
    sendPopupVisible: false,
    sendingType: null,
    agentArrWithId: null,
    draftName: "",
    showPopup: false,
    sourceStatus: "",
    formId: null,
    sendApendixPopupVisible: false,
    dataSetsLoaded: false,
    // Auto-save (silent draft saving)
    autoSaveEnabled:
      typeof localStorage !== "undefined"
        ? localStorage.getItem("form_autosave") !== "off"
        : true,
    isAutoSaving: false,
    lastSavedAt: null,
    _dirtyCount: 0,
  };
}

export default function useFormState() {
  const [state, setState] = useState(getDefaultState);

  const updateState = useCallback((partialOrFn) => {
    setState((prev) => {
      const partial = typeof partialOrFn === "function" ? partialOrFn(prev) : partialOrFn;
      return { ...prev, ...partial };
    });
  }, []);

  const resetState = useCallback(() => {
    setState(getDefaultState());
  }, []);

  const resetWithFormChange = useCallback(() => {
    setState({ ...getDefaultState(), formHasChanged: true });
  }, []);

  return { state, updateState, resetState, resetWithFormChange };
}
